<template>
    <div>
        <div id="big">
            <div class="bigContainer">
                <div class="modal fade" id="addRecord" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel"><strong>
                                        <i class="fa-solid fa-plus"></i> Thêm khóa học</strong></h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" class="text-danger"><i
                                            class="fa-regular fa-circle-xmark"></i></span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form @submit.prevent="addRecord()">
                                    <div class="form-group">
                                        <label class="bold">Tên khóa học</label>
                                        <input v-model="record.course_name" type="text" class="form-control form-control-sm" id="exampleInputEmail1"
                                            aria-describedby="emailHelp" placeholder="Tên khóa học">
                                        <span v-if="errors.course_name" class="text-danger">{{ errors.course_name[0] }}<br></span>
                                    </div>

                                    <div class="form-group">
                                        <label for="exampleInputEmail1" class="bold">Link video Trailer</label>
                                        <input v-model="record.course_trailer" type="text" class="form-control form-control-sm" id="exampleInputEmail1"
                                            aria-describedby="emailHelp"
                                            placeholder="Theo cấu trúc : https://www.youtube.com/watch?v=5fnAAwP_xOs">
                                        <span v-if="errors.course_trailer" class="text-danger">{{ errors.course_trailer[0] }}<br></span>
                                    </div>

                                    <div class="form-group">
                                        <label for="exampleInputEmail1" class="bold">Mô tả khóa học</label>
                                        <div>
                                            <RichTextEditor v-model="record.course_introduce" />
                                        </div>
                                        <span v-if="errors.course_introduce" class="text-danger">{{ errors.course_introduce[0] }}<br></span>
                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                            <div class="big-container-image">
                                                <div class="inner-image-upload">
                                                    <label class="bold"><i class="fa-solid fa-wand-magic-sparkles"></i> Ảnh bìa khóa
                                                        học</label>
                                                    <div class="min-image-upload">
                                                        <input class="input-file" type="file" @change="previewImage"
                                                            accept="image/*" ref="fileInput" />
                                                        <span class="iconClound" v-if="previewImageSrc == null"><i
                                                                class="fa-solid fa-cloud-arrow-up"></i></span>
                                                        <div v-if="previewImageSrc" class="box-preview">
                                                            <img class="preview" :src="previewImageSrc" alt="Preview" />
                                                            <img src="@/assets/error.png" @click="removeFile"
                                                                class="close-img" alt="Remove">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <span v-if="errors.course_image" class="text-danger">{{ errors.course_image[0] }}<br></span>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <label class="bold" for="exampleInputPassword1">Giá tiền (VNĐ)</label>
                                                <input v-model="record.course_price" type="text" class="form-control" id="exampleInputPassword1"
                                                    placeholder="99.99">
                                                <span v-if="errors.course_price" class="text-danger">{{ errors.course_price[0] }}<br></span>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" class="btn-pers" id="login_button"><i class="fa-solid fa-plus"></i> Thêm</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserRequest from '@/restful/UserRequest';
import RichTextEditor from '@/components/common/RichTextEditor.vue'

export default {
    name: "AddRecord",
    components: {
        RichTextEditor,
    },
    props: {

    },
    setup() {

    },
    data() {
        return {
            previewImageSrc: null,
            updateImage: false,
            record: {
                course_name: null,
                course_image: null,
                course_trailer: null,
                course_introduce: null,
                course_price: null,
            },
            errors: {
                course_name: null,
                course_image: null,
                course_trailer: null,
                course_introduce: null,
                course_price: null,
            }
        }
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        previewImage(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.previewImageSrc = e.target.result;
                    this.record.course_image = file;
                    this.updateImage = true;
                };
                reader.readAsDataURL(file);
            } else this.removeFile();
        },
        removeFile: function () {
            this.previewImageSrc = null;
            // this.user.avatar = null;
            this.$refs.fileInput.value = '';
            this.updateImage = false;
        },
        addRecord: async function () {
            try {
                const formData = new FormData();
                for (let key in this.record) formData.append(key, this.record[key]);
                // var fields = ['course_name', 'course_trailer', 'course_introduce', 'course_price', 'course_image'];
                // for (var field of fields) formData.append(field, this.user[field]);
                // if (this.updateImage) formData.append('course_image', this.record.course_image);
                // // console.log(formData);

                const { messages } = await UserRequest.post('admin/course/create', formData, true);
                this.$emitEvent('eventSuccess', messages[0]);
                for (let key in this.errors) this.errors[key] = null;
                var closePW = window.document.getElementById('addRecord');
                closePW.click();
                this.record = {
                    course_name: null,
                    course_image: null,
                    course_trailer: null,
                    course_introduce: null,
                    course_price: null,
                };
                this.previewImageSrc = null;
                this.$emitEvent('eventRegetDataRecords', '');
            }
            catch (error) {
                if (error.errors) this.errors = error.errors;
                else for (let key in this.errors) this.errors[key] = null;
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
            }

        },
    },
    watch: {

    },
}
</script>

<style scoped src="@/components/modal-responsive.css"></style>
<style scoped>
/* image upload */
.big-container-image {
    display: flex;
    align-items: center;
    align-content: center;
    /* height: 100%; */
}

.inner-image-upload {
    height: 50%;
    width: 100%;
}

.min-image-upload {
    background-color: #e9ecef;
    position: relative;
    text-align: center;
    /* width: 170px; */
    height: 170px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease;
    width: 100%;
}

.min-image-upload .preview {
    /* width: 150px; */
    height: 150px;
    object-fit: cover;
    border-radius: 6px;
    cursor: default;
    width: 100%;
}

.min-image-upload:hover {
    transition: all 0.5s ease;
    background: #E8F5E9;
}

.input-file {
    opacity: 0;
    top: 0px;
    left: 0px;
    position: absolute;
    cursor: pointer;
    /* width: 150px; */
    height: 150px;
    width: 100%;
}

.box-preview {
    position: relative;
}

.iconClound {
    cursor: pointer;
    font-size: 60px;
    color: var(--user-color);
}

.close-img {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 16px;
}

/* image upload */


/*  */
.modal-dialog {
    max-width: 800px;
}

/*  */


.modal.fade.show {
    padding-left: 0px;
}

.modal-content {
    /* margin-top: 100px; */
    border-radius: 10px;
}

.bigContainer .input-form {
    height: 40px;
    width: 100%;
    position: relative;
}

.bigContainer .input-form input {
    height: 100%;
    width: 100%;
    border: none;
    font-size: 17px;
    border-bottom: 2px solid silver;
    outline: none !important;
}

.input-form input:focus~label,
.input-form input:valid~label {
    transform: translateY(-20px);
    font-size: 15px;
    color: var(--user-color);
}

.input-form .underline.fix2:before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: var(--user-color);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
}

.bigContainer .input-form label {
    position: absolute;
    bottom: 0px;
    left: 0;
    color: grey;
    pointer-events: none;
    transition: all 0.3s ease;
}

.input-form .underline {
    position: absolute;
    height: 2px;
    width: 100%;
    bottom: 0;
}

.input-form .underline:before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: var(--user-color);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
}

.input-form input:focus~.underline:before,
.input-form input:valid~.underline:before {
    transform: scaleX(1);
}

@import url('https://fonts.googleapis.com/css2?family=Reem+Kufi+Ink');

#big {
    display: flex;
    position: relative;
}

.btn-pers {
    position: relative;
    left: 50%;
    padding: 1em 2.5em;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    font-weight: 700;
    color: #000;
    background-color: #fff;
    border: none;
    border-radius: 45px;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease 0s;
    cursor: pointer;
    outline: none;
    transform: translateX(-50%);
}

.btn-pers:hover {
    background-color: var(--user-color);
    box-shadow: var(--btn-hover);
    color: #fff;
    transform: translate(-50%, -7px);
}

.btn-pers:active {
    transform: translate(-50%, -1px);
}

#inputPassword {
    padding-right: 26px;
}
</style>
